import { splitProps } from "solid-js";
import type { JSX, ParentProps } from "solid-js";

export type ChipTone = "neutral" | "livre" | "ocupada" | "aguardando" | "danger" | "success" | "warning" | "info";

interface Props extends JSX.HTMLAttributes<HTMLSpanElement> {
    tone?: ChipTone;
    size?: "sm" | "md";
}

export function Chip(props: ParentProps<Props>) {
    const [own, rest] = splitProps(props, ["tone", "size", "class", "children"]);
    const cls = () =>
        [
            "ui-chip",
            `ui-chip-${own.tone ?? "neutral"}`,
            `ui-chip-${own.size ?? "md"}`,
            own.class ?? "",
        ]
            .filter(Boolean)
            .join(" ");
    return (
        <span {...rest} class={cls()}>
            {own.children}
        </span>
    );
}
